import React from 'react';
import Helmet from 'react-helmet';
import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Container,
} from '@material-ui/core';
import { graphql } from 'gatsby';
// eslint-disable-next-line import/no-unassigned-import
import './css/contentful-pages.css';
import { DEFAULT_LANGUAGE } from '../providers/LanguageProvider';
import Categories from '../components/blog/categories';
import colors from '../themes/main-colors';
import { useTranslation } from '../hooks/useTranslation';
import { BlogTopicFragment } from '../__generated__/gatsby-types';
import { useIsMobile } from '../util/style-utils';
import RelatedPosts from '../components/blog/related-posts';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        padding: '0 67px 60px',
      },
    },
    navLine: {
      marginBottom: 0,
      color: `${colors.noirBlur}`,
      backgroundColor: `${colors.noirBlur}`,
    },
    borderLine: {
      borderTop: `1px solid ${colors.gray82}`,
    },
    hr: {
      margin: '30px 0',
      color: colors.lightGray1,
      backgroundColor: colors.lightGray1,
      borderColor: colors.lightGray1,
      borderStyle: 'solid',
    },
  }),
);

export const BlogTopicTemplate = ({ pageContext, data }: any) => {
  const classes = useStyles();
  const { t, inlineRichT } = useTranslation();
  const isMobile = useIsMobile();

  const currentTopic: BlogTopicFragment = data?.topicData?.nodes.filter(
    // (node: BlogTopicFragment) => node.node_locale === language,
    (node: BlogTopicFragment) => node.node_locale === DEFAULT_LANGUAGE, // Temporarily disable localization on public pages.
  )[0];

  return (
    <>
      <Helmet bodyAttributes={{ class: 'TemplatePage' }}>
        <title>
          {t('BLOG_HOME')} | {currentTopic.topic}
        </title>
      </Helmet>
      {!isMobile && <hr className={classes.navLine} />}
      <Container maxWidth="lg" style={{ paddingRight: 0, paddingLeft: 0 }}>
        <Categories />
      </Container>
      <Box className={classes.borderLine}>
        <Container maxWidth="lg" className={classes.root}>
          <RelatedPosts
            title={`${currentTopic.topic} ${t('RELATED')}`}
            currentTopic={currentTopic}
            data={data}
            topicHeader={inlineRichT('BLOG_TOPIC_TITLE', {
              TOPIC: currentTopic.topic,
            })}
          />
        </Container>
      </Box>
    </>
  );
};
export default BlogTopicTemplate;

export const query = graphql`
  query topicPageQuery($slug: String!) {
    topicData: allContentfulBlogTopic(filter: { slug: { eq: $slug } }) {
      nodes {
        ...BlogTopic
      }
    }
    articleData: allContentfulArticle(
      filter: {
        topics: { elemMatch: { slug: { eq: $slug } } }
        slug: { ne: null }
      }
      sort: { fields: [publishDate, updateDate], order: [DESC, DESC] }
    ) {
      nodes {
        ...BlogArticle
      }
    }
  }
`;
